export function classNames(
    ...classes: (boolean | null | undefined | string)[]
): string {
    return classes.filter(Boolean).join(' ');
}
